"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var enums_1 = require("@ikea-aoa/enums");
var ProductPriceInformationSummaryTransformer_1 = __importDefault(require("./ProductPriceInformationSummaryTransformer"));
/**
 * Price utilities.
 */
var PriceUtility = /** @class */ (function () {
    function PriceUtility() {
    }
    /**
     * Check if shoppingProducts has a family price.
     *
     * @param shoppingProducts Shopping products.
     * @returns If it is family price.
     */
    PriceUtility.isFamilyPrice = function (shoppingProducts) {
        return shoppingProducts.some(function (shoppingProduct) {
            var _a, _b;
            return ProductPriceInformationSummaryTransformer_1.default.transform((_b = (_a = shoppingProduct === null || shoppingProduct === void 0 ? void 0 : shoppingProduct.product) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.priceInformation).familyPrice;
        });
    };
    /**
     * Returns true if it is just one product.
     *
     * @param shoppingProducts Shopping products.
     * @returns True if just one product.
     */
    PriceUtility.isIndividualProduct = function (shoppingProducts) {
        return shoppingProducts.length === 1 && shoppingProducts[0].quantity === 1;
    };
    /**
     * Returns "true" if TRO or family.
     *
     * @param totalPrice Price model.
     * @returns "true" if TRO or family.
     */
    PriceUtility.isTroOrFamily = function (totalPrice) {
        return totalPrice.family || Boolean(totalPrice.temporary && totalPrice.validDateInterval);
    };
    /**
     * Returns "true" if TRO.
     *
     * @param totalPrice Price model.
     * @returns "true" if TRO.
     */
    PriceUtility.isTro = function (totalPrice) {
        return !totalPrice.family && Boolean(totalPrice.temporary && totalPrice.validDateInterval);
    };
    /**
     * Returns "true" if family.
     *
     * @param totalPrice Price model.
     * @returns "true" if TRO.
     */
    PriceUtility.isFamily = function (totalPrice) {
        return totalPrice.family;
    };
    /**
     * The price unit.
     *
     * @param shoppingProducts Shopping products.
     * @returns The price unit.
     */
    PriceUtility.getPriceUnit = function (shoppingProducts) {
        var product = shoppingProducts[0].product;
        if (!product.content || !product.content.priceUnit || !product.content.priceUnit[0]) {
            return null;
        }
        var priceUnit = product.content.priceUnit[0];
        // TODO: Remove this when DEXF handles putting a space between number and word (example: "4styck" should be "4 styck")
        return priceUnit.text
            .replace(/([0-9])([a-zA-Z])/g, '$1 $2')
            .replace(/([a-zA-Z])([0-9])/g, '$1 $2');
    };
    /**
     * Returns valid interval.
     *
     * @param totalPrice Price model.
     * @param localizedInformation
     * @param localizedInformation.translations
     * @param localizedInformation.translations.priceInfoTemporaryPricePeriodEnd
     * @param localizedInformation.translations.priceInfoTemporaryPriceDisclaimer
     * @param localizedInformation.priceSettings
     * @param localizedInformation.priceSettings.temporaryPricePeriod
     * @returns Interval.
     */
    PriceUtility.getValidInterval = function (totalPrice, localizedInformation) {
        var translations = localizedInformation.translations, priceSettings = localizedInformation.priceSettings;
        var _a = totalPrice.validDateInterval, validFrom = _a.validFrom, validTo = _a.validTo;
        var priceInfoTemporaryPricePeriodEnd = translations.priceInfoTemporaryPricePeriodEnd, priceInfoTemporaryPriceDisclaimer = translations.priceInfoTemporaryPriceDisclaimer;
        return (enums_1.TemporaryPricePeriodEnum.periodEnd === priceSettings.temporaryPricePeriod
            ? [priceInfoTemporaryPricePeriodEnd, validTo, priceInfoTemporaryPriceDisclaimer]
            : [validFrom, '-', validTo, priceInfoTemporaryPriceDisclaimer]).join(' ');
    };
    /**
     * Returns price excl tax.
     *
     * @param totalPrice Price model.
     * @returns Price excl tax.
     */
    PriceUtility.getPriceExclTax = function (totalPrice) {
        return totalPrice.familyExclTax || totalPrice.exclTax;
    };
    /**
     * Returns price.
     *
     * @param totalPrice Price model.
     * @returns Price.
     */
    PriceUtility.getPrice = function (totalPrice) {
        return totalPrice.familyInclTax || totalPrice.inclTax;
    };
    return PriceUtility;
}());
exports.default = PriceUtility;
//# sourceMappingURL=PriceUtility.js.map